import { useState, useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const PhotoGallery = ({ photos, initialIndex = 0, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
      if (e.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);

  const prev = () => {
    setCurrentIndex((curr) => (curr === 0 ? photos.length - 1 : curr - 1));
  };

  const next = () => {
    setCurrentIndex((curr) => (curr === photos.length - 1 ? 0 : curr + 1));
  };

  return (
    <div className="fixed inset-0 z-[200] bg-black/95 flex items-center justify-center">
      <Button
        onClick={onClose}
        variant="ghost"
        size="icon"
        className="absolute top-4 right-4 text-white hover:bg-white/20 rounded-full"
      >
        <X className="w-6 h-6" />
      </Button>

      {photos.length > 1 && (
        <>
          <Button
            onClick={prev}
            variant="ghost"
            size="icon"
            className="absolute left-4 text-white hover:bg-white/20 rounded-full"
          >
            <ChevronLeft className="w-8 h-8" />
          </Button>

          <Button
            onClick={next}
            variant="ghost"
            size="icon"
            className="absolute right-4 text-white hover:bg-white/20 rounded-full"
          >
            <ChevronRight className="w-8 h-8" />
          </Button>
        </>
      )}

      <div className="max-w-5xl max-h-[90vh] w-full h-full flex items-center justify-center p-8">
        <img
          src={photos[currentIndex]}
          alt={`Photo ${currentIndex + 1}`}
          className="max-w-full max-h-full object-contain rounded-lg"
        />
      </div>

      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full text-sm">
        {currentIndex + 1} / {photos.length}
      </div>
    </div>
  );
};
